// External Dependencies
import React from 'react';
import { Link } from 'react-router';
import AppBar from 'material-ui/AppBar';
import FlatButton from 'material-ui/FlatButton';
import {
  blueGrey900,
  deepOrange50,
  red400,
} from 'material-ui/styles/colors';

// Internal Dependencies
import { AppBarStrings } from '../common/strings';

// Local variables
const logo = `${window.location.pathname}images/logo.png`;

const appBarStyles = {
  background: blueGrey900,
  borderBottomStyle: 'solid',
  borderBottomColor: red400,
  verticalAlign: 'middle',
};

const buttonStyles = {
  color: deepOrange50,
  borderRadius: 0,
  marginRight: 30,
  marginTop: 20,
  transform: 'translateY(-6px)',
};

const logoStyles = {
  height: 70,
  width: 140,
  paddingLeft: 20,
};

const buttonPanel = (
  <div>
    <Link to="/Home">
      <FlatButton
        hoverColor={red400}
        label={AppBarStrings.HOME}
        style={buttonStyles}
      />
    </Link>
    <Link to="/BadgeList">
      <FlatButton
        hoverColor={red400}
        label={AppBarStrings.BADGES}
        style={buttonStyles}
      />
    </Link>
    <Link to="/CodersPage">
      <FlatButton
        hoverColor={red400}
        label={AppBarStrings.CODERS}
        style={buttonStyles}
      />
    </Link>
  </div>
);

// Component definition
const DojoAppBar = () => (
  <AppBar
    iconElementLeft={
      <Link to="/home">
        <img alt={logo} src={logo} style={logoStyles} />
      </Link>
    }
    iconElementRight={buttonPanel}
    style={appBarStyles}
  />
);

export default DojoAppBar;



/** WEBPACK FOOTER **
 ** ./src/app-main-container/app-bar.js
 **/